export const urlQueryStringToObj = (str) => {
  const toReturn = {};
  new URLSearchParams(str).forEach((value, key) => {
    toReturn[key] = value;
  });
  return toReturn;
};
